import {SET_SELECTION_DATA} from '../actions';
import {
  SelectedCheckBoxModel,
  SelectedCheckBoxModelActions
} from '../mappers/SelectedCheckBoxTypesMapper';
import produce, {Draft} from 'immer';
export const initialSelectedCheckBoxState: SelectedCheckBoxModel = {
  selectionData: []
};

export const selectedCheckBoxReducer = produce(
  (
    state: Draft<SelectedCheckBoxModel>,
    action: SelectedCheckBoxModelActions
  ) => {
    if (action.type === SET_SELECTION_DATA) {
      const listData: any = action.payload?.data;
      state.selectionData = listData;
    }
  },
  initialSelectedCheckBoxState
);
